<template>
  <div class="container-fluid mt-5">
    <card v-if="loading">
      <template slot="image">
        <div class="col-12 text-center mt-5" slot="empty">
          <img
            src="/img/loading.gif"
            style="height: 100px; width: 100px"
            alt=""
          />
        </div>
      </template>
    </card>
    <div v-else>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0">
                {{ category.name }}
                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_WAREHOUSES)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editCategory()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_DELETE_WAREHOUSES)"
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteCategory()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'categories'"
                :objectId="category.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <category-view-global
                    :category="category"
                    @categoryUpdated="get"
                  />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <category-view-logs :category="category" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import { TabPane, Tabs } from "@/components";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import defaultCategory from "./defaultCategory";
import CategoryViewGlobal from "./partials/CategoryViewGlobal.vue";
import CategoryViewLogs from "./partials/CategoryViewLogs.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    CategoryViewGlobal,
    CategoryViewLogs,
    NotificationSubscription,
  },

  mixins: [],

  data() {
    return {
      loading: true,
      category: cloneDeep(defaultCategory),
    };
  },

  computed: {},

  watch: {
    "$route.params.id": function () {
      this.get();
    },
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("categories/get", id);
        this.category = this.$store.getters["categories/category"];
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editCategory(row) {
      this.$router.push({
        name: "Edit Category",
        params: { id: this.category.id },
      });
    },

    async deleteCategory() {
      const confirmation = await swal.fire({
        title: this.$t("CATEGORIES.DELETE_THIS_CATEGORIES"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("categories/destroy", this.category.id);
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("CATEGORIES.CATEGORY_DELETED"),
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    goBack() {
      this.$router.push({ name: "List Categories" });
    },
  },
};
</script>
